// generated from 1_450 samples

import { z } from "zod";
import { common } from "../common";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const campaignLinkClickedFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("campaign_link_clicked_filter"),
  comparison_key: z.enum([
    "7", // 1_286 (88.69%)
    "8", // 164 (11.31%)
  ]),
  display_name: z.string(),
  // undefined: 203 (14.00%), defined 1_247 (86.00%)
  raw_value: z
    .object({
      prefilter_value: z.object({
        mc_id: common.objectId,
        mv_id: common.objectId,
        wf_id: z.null(),
      }),
      value: z.object({
        link_id: common.objectId,
        // avg: 2002.32, min: 1, max: 44355
        short_id: z.int().min(1),
      }),
    })
    .optional(),
  value: z.object({
    id: z.object({
      link_id: common.objectId,
      // avg: 1775.42, min: 1, max: 44355
      short_id: z.int().min(1),
    }),
    pre_filter_value: z.object({
      id: z.object({
        mc_id: common.objectId,
        mv_id: common.objectId,
        wf_id: z.null(),
      }),
      value: z.string(),
    }),
    value: z.string(),
  }),
  varies_by_app_group: z.literal(true),
});
